export default __webpack_public_path__ + "static/media/2021.f9e3f424.jpg";